import React from 'react';
import bg from '../media/Sfondo.webp';
import PrimaryButton from '../components/PrimaryButton';
import SecondaryButton from '../components/SecondaryButton';
import Typewriter from '../components/Typewriter';
import ContactSection from '../components/Contact';
import AboutSection from '../components/AboutSection';
import Projects from "../components/Projects";
import SkillsSection from '../components/Skills';
import Footer from '../components/Footer';
import {useNavigate} from "react-router-dom";

const Home = () => {

    const navigate = useNavigate();

    return (
        <div className="relative w-full min-h-screen overflow-x-hidden bg-earth-50">
            <section id="home" className="relative h-screen overflow-hidden">
                <img src={bg} alt="Sunset background" className="absolute inset-0 w-full h-full object-cover object-center" />

                <div className="relative z-10 flex items-center justify-end h-full">
                    <div className="mx-auto flex flex-col justify-center items-end max-w-7xl w-full px-8 lg:px-6">
                        <div className="mt-40 lg:mt-16">
                            <p className="text-[#E5DACF] font-bold text-2xl lg:text-4xl">Alessio Pannozzo</p>
                        </div>

                        <h1 className="text-3xl lg:text-6xl text-right font-bold text-[#E5DACF] leading-tight mb-2">
                            Computer Science Student
                        </h1>

                        <p className="text-[#E5DACF] text-lg lg:text-xl text-right font-semibold mb-4 w-full h-3 pb-14 lg:pb-0 max-w-md sm:max-w-2xl lg:max-w-4xl">
                            <Typewriter
                                strings={[
                                    'Exploring new AI technologies and their applications',
                                    'Exploring nature and its beauty through photography',
                                ]}
                                typingSpeed={60}
                                deletingSpeed={40}
                                pause={1700}
                            />
                        </p>

                        <div className="flex flex-col sm:flex-row gap-4 w-3/5 sm:w-auto lg:mt-8">
                            <PrimaryButton onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}>
                                View My Projects
                            </PrimaryButton>
                            <SecondaryButton onClick={() => navigate('/wallpapers')}>
                                View My Wallpapers
                            </SecondaryButton>
                        </div>
                    </div>
                </div>
            </section>

            <section id="about" className="scroll-mt-24">
                <AboutSection/>
            </section>

            <section id="projects" className="scroll-mt-24">
                <Projects/>
            </section>

            <section id="skills" className="scroll-mt-24">
                <SkillsSection/>
            </section>

            <section id="contact" className="scroll-mt-24 px-8 lg:px-6 max-w-7xl mx-auto">
                <ContactSection />
            </section>

            <Footer />
        </div>
    );
};

export default Home;
